import { css } from '@emotion/react'
// import React from 'react'
import { Component, memo } from 'react';
// import PropTypes from 'prop-types';
import loadable from "@loadable/component"
import {
  Container,
  Typography,
  Grid,
  Dialog,
  TextField,
  Button,
} from '@material-ui/core';
import namesCompany from '../../helpers/NameCompany'
import { SendWhatsappService } from '../../services/LandingV4/sendWhatsapp'

const SimuladorCard = loadable(() => import('../pages/SimuladorCard'))
const CarouselCard = loadable(() => import('../carousel/CarouselCard'))

const simuladorCss = css`
    margin-top: 10px;
`

const whatsappDialogPaperStyle = {
  backgroundColor: '#fff',
  borderRadius: 14,
  color: '#1c1c1c',
  width: '100%',
  maxWidth: 520,
  boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
}

const whatsappMessageBoxStyle = {
  backgroundColor: '#F6F7F9',
  border: '1px solid rgba(0,0,0,0.10)',
  borderRadius: 12,
  padding: '14px 16px',
  textAlign: 'center',
  width: '100%',
}

const whatsappButtonStyle = { minWidth: 140, borderRadius: 10 }

const whatsappCancelButtonStyle = { minWidth: 140, borderRadius: 10 }

class Simulador extends Component {
  constructor(props) {
    super(props);

    this.whatsappSendLock = false

    this.state = {
      headerless: true,
      whatsappPopupOpen: false,
      whatsappPopupStep: 1,
      whatsappPhone: '',
      whatsappSending: false,
      whatsappSent: false,
    }
  }

  onProspectingSimuladorLoaded = (simuladorInfo) => {
    const prospeccionIa = simuladorInfo?.prospeccion_ia
    const shouldShowPopup = prospeccionIa === true || prospeccionIa === 'true'
    this.setState({ whatsappPopupOpen: shouldShowPopup })
  }

  async componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search)
    let df;
    if (urlParams.has('headerless')) {
      df = urlParams.get('headerless')
      if (df === 'true') {
        this.setState({ headerless: true })
      } else {
        this.setState({ headerless: false })
      }
    }
  }

  onWhatsappPhoneChange = (event) => {
    const value = `${event.target.value || ''}`
    const digitsOnly = value.replace(/\D/g, '').slice(0, 10)
    this.setState({ whatsappPhone: digitsOnly })
  }

  getIdSolicitud = () => {
    try {
      const urlParams = new URLSearchParams(window.location.search)
      const urlId = `${urlParams.get('creditApplicationId') || ''}`
      if (urlId) return urlId

      const flujoRaw = sessionStorage.getItem('flujo')
      if (flujoRaw) {
        const flujo = JSON.parse(flujoRaw || '{}')
        const sessionId = `${flujo?.creditApplicationId || ''}`
        if (sessionId) return sessionId
      }

      return ''
    } catch (e) {
      return ''
    }
  }

  sendWhatsappLead = (phone) => {
    try {
      const empresa = `${this.props.pageContext?.company || 'FISA'}`
      const idSolicitud = this.getIdSolicitud()
      const sendWhatsappService = new SendWhatsappService()
      sendWhatsappService.setPhone(phone)
      sendWhatsappService.setIdSolicitud(idSolicitud)
      sendWhatsappService.setAgent('prospecting')
      sendWhatsappService.setEmpresa(empresa)
      sendWhatsappService.setAppName('prospecting-agent')

      return sendWhatsappService.send()
    } catch (e) {
      console.error('Error sending send-whatsapp payload', e)
      return Promise.reject(e)
    }
  }

  closeWhatsappPopup = () => {
    this.setState({ whatsappPopupOpen: false })
  }

  continueWhatsappStep1 = () => {
    const { whatsappPhone, whatsappSending, whatsappSent } = this.state
    const isValidPhone = /^\d{10}$/.test(`${whatsappPhone}`)
    if (!isValidPhone) return

    if (this.whatsappSendLock || whatsappSending || whatsappSent) return

    this.whatsappSendLock = true

    const digitsOnly = `${whatsappPhone || ''}`.replace(/\D/g, '').slice(0, 10)

    this.setState({ whatsappPopupStep: 2, whatsappSending: true })

    this.sendWhatsappLead(digitsOnly)
      .then((res) => {
        console.info('send-whatsapp payload sent', res?.status)
      })
      .catch((err) => {
        console.error('Error sending send-whatsapp payload', err)
      })
      .then(() => {
        this.setState({ whatsappSending: false, whatsappSent: true })
      })
  }

  renderWhatsappPopup() {
    const { whatsappPopupOpen, whatsappPopupStep, whatsappPhone, whatsappSending, whatsappSent } = this.state
    const isValidPhone = /^\d{10}$/.test(`${whatsappPhone}`)

    const step1Body = (
      <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 14, alignItems: 'center', minHeight: 320 }}>
        <div style={whatsappMessageBoxStyle}>
          <Typography variant="body1" style={{ color: '#1c1c1c' }}>
            {`"¡Tu crédito a un mensaje de distancia! Olvídate de los formularios. Solo ingresa tu celular y un asesor personal te guiará por WhatsApp para solicitar tu préstamo hoy mismo."`}
          </Typography>
        </div>

        <TextField
          variant="outlined"
          value={whatsappPhone}
          onChange={this.onWhatsappPhoneChange}
          placeholder="Teléfono 10 Digitos"
          fullWidth
          disabled={whatsappSending || whatsappSent}
          inputProps={{ inputMode: 'numeric', style: { textAlign: 'center', letterSpacing: 2 } }}
        />

        <div style={{ width: '100%', marginTop: 'auto', display: 'flex', justifyContent: 'space-between', gap: 12 }}>
          <Button
            color="primary"
            variant="contained"
            style={whatsappButtonStyle}
            disabled={!isValidPhone || whatsappSending || whatsappSent}
            onClick={this.continueWhatsappStep1}
          >
            Continuar
          </Button>
          <Button
            color="primary"
            variant="outlined"
            style={whatsappCancelButtonStyle}
            disabled={whatsappSending || whatsappSent}
            onClick={this.closeWhatsappPopup}
          >
            Cancelar
          </Button>
        </div>
      </div>
    )

    const step2Body = (
      <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 14, alignItems: 'center', minHeight: 260 }}>
        <div style={{ flex: 1, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={whatsappMessageBoxStyle}>
            <Typography variant="body1" style={{ color: '#1c1c1c' }}>
              En unos momentos te contactaremos por whatsapp.
            </Typography>
          </div>
        </div>

        <div style={{ width: '100%', marginTop: 'auto', display: 'flex', justifyContent: 'space-between', gap: 12 }}>
          <Button
            color="primary"
            variant="contained"
            style={whatsappButtonStyle}
            disabled
          >
            Continuar
          </Button>
          <Button
            color="primary"
            variant="outlined"
            style={whatsappCancelButtonStyle}
            disabled
          >
            Cancelar
          </Button>
        </div>
      </div>
    )

    return (
      <Dialog
        open={whatsappPopupOpen}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.35)' } }}
        PaperProps={{ style: whatsappDialogPaperStyle }}
      >
        {whatsappPopupStep === 1 ? step1Body : step2Body}
      </Dialog>
    )
  }

  render() {
    const { headerless } = this.state
    return (
      <Container>
        {this.renderWhatsappPopup()}
        <Grid container spacing={2} alignItems="center">
          {
            !headerless && <Grid item xs={12} md={3}></Grid>
          }

          <Grid item xs={12} md={6}>
            <div>
              <Typography color="primary" variant="h6" align="center">
                {namesCompany(this.props.pageContext.company).slogan}
              </Typography>

              <div css={simuladorCss}>
                <SimuladorCard
                  pageContext={this.props.pageContext}
                  onProspectingSimuladorLoaded={this.onProspectingSimuladorLoaded}
                />
              </div>
              
            </div>
          </Grid>

          {
            !headerless && <Grid item xs={12} md={3}></Grid>
          }

          {
            headerless &&
            <Grid item xs={12} md={6}>
              <CarouselCard company={this.props.pageContext.company} />
            </Grid>
          }
        </Grid>

      </Container>
    );
  }
}

export default memo(Simulador);